<template>
    <div class="content">
        <div style="position: relative;height: 85vh;">
            <div id="time-select">
                <el-radio-group v-model="timeSelect">
                    <el-radio-button label="全部时间"></el-radio-button>
                    <el-radio-button label="最近一月"></el-radio-button>
                    <el-radio-button label="最近一季度"></el-radio-button>
                    <el-radio-button label="最近一年"></el-radio-button>
                </el-radio-group>
            </div>
            <div id="unit-rank-bar" ref="RankBar" @mouseover="stopRolling" @mouseout="startRolling"></div>
        </div>
    </div>
</template>

<script>
    import options from './../../../../utils/options'
    import echarts from "echarts";
    import {getUnitRank} from "../../../../network/compileAnalysis";


    export default {
        name: "Ranksv2",
        props: ['unitRankData', 'selectArea'],

        data() {
            return {
                chartBarRank: '',
                optionRankBar: options.optionRankBar,
                viewCount: 10,
                rollingCount: 0,
                rollingNum: 10,
                rollingFlag: '',
                rollingEvent: {},
                dataInfo: [],
                timeSelect: '全部时间',
                legendSelectBiao: true,
            }
        },

        computed: {
            dataCount() {
                return this.dataInfo.yAxis_biao.length
            },
            zoomStart() {
                let start = this.rollingCount * this.rollingNum * 100 / this.dataCount;
                if (start > 50) {
                    start += 1
                }
                return start
            },
            zoomEnd() {
                let end = (this.rollingCount * this.rollingNum + this.viewCount) * 100 / this.dataCount - 1
                if (end < 50) {
                    end -= 1
                }
                return end
            }
        },

        watch: {
            unitRankData: {
                handler(val) {
                    this.rollingFlag = false;
                    this.rollingCount = 0;
                    this.dataInfo = this.formatDate(val);
                    this.chartsLoadingBiao();
                    this.chartBarRank.hideLoading();
                },
                deep: true,
            },

            timeSelect(val) {
                this.chartBarRank.showLoading();
                getUnitRank(this.selectArea, val).then(res => {
                    this.unitRankData = res.data.result
                })
            },
            selectArea() {
                this.chartBarRank.showLoading();
            },

            rollingCount() {
                if (this.legendSelectBiao) {
                    this.chartsLoadingBiao()
                } else {
                    this.chartsLoadingShu()
                }
            },

            rollingFlag(val) {
                if (val) {
                    this.rollingEvent = setInterval(() => {
                        if (this.rollingCount === Math.ceil(this.dataCount / this.viewCount) - 1) {
                            this.rollingCount = 0
                        } else {
                            this.rollingCount++
                        }
                    }, 5000)
                } else {
                    clearInterval(this.rollingEvent)
                }
            },
        },

        methods: {
            chartInit() {
                this.chartBarRank = echarts.init(this.$refs.RankBar);
                this.chartBarRank.on('legendselectchanged', this.legendSelect);
            },

            chartsLoadingBiao() {
                if (this.selectArea === '全国') {
                    this.optionRankBar.title.text = '全国业绩排行榜（前50名）'
                } else {
                    this.optionRankBar.title.text = this.selectArea + '业绩排行榜（前20名）'
                }
                this.optionRankBar.dataZoom[0].start = this.zoomStart;
                this.optionRankBar.dataZoom[0].end = this.zoomEnd;
                this.optionRankBar.legend.selected = {'报告表': true, '报告书': false};
                this.optionRankBar.yAxis.data = this.dataInfo.yAxis_biao;
                this.optionRankBar.series[0].data = this.dataInfo.xAxis_biao.map((item, i) => {
                    let colorList = ['#f36c6c', '#e6cf4e', '#20d180', '#0093ff'];
                    let itemStyle = {
                        color: i > 3 ? colorList[3] : colorList[i]
                    };
                    return {
                        value: item,
                        itemStyle: itemStyle,
                        avg: this.dataInfo.avg_biao,
                        area: this.selectArea
                    };
                });

                this.optionRankBar.series[1].data = [];
                this.chartBarRank.setOption(this.optionRankBar, true);
                // this.startRolling()
            },

            chartsLoadingShu() {
                if (this.selectArea === '全国') {
                    this.optionRankBar.title.text = '全国业绩排行榜（前50名）'
                } else {
                    this.optionRankBar.title.text = this.selectArea + '业绩排行榜（前20名）'
                }
                this.optionRankBar.dataZoom[0].start = this.zoomStart;
                this.optionRankBar.dataZoom[0].end = this.zoomEnd;
                this.optionRankBar.legend.selected = {'报告表': false, '报告书': true};
                this.optionRankBar.yAxis.data = this.dataInfo.yAxis_shu;
                this.optionRankBar.series[1].data = this.dataInfo.xAxis_shu.map((item, i) => {
                    let colorList = ['#f36c6c', '#e6cf4e', '#20d180', '#0093ff'];
                    let itemStyle = {
                        color: i > 3 ? colorList[3] : colorList[i]
                    };
                    return {
                        value: item,
                        itemStyle: itemStyle,
                        avg: this.dataInfo.avg_shu,
                        area: this.selectArea
                    };
                });
                this.optionRankBar.series[0].data = [];
                this.chartBarRank.setOption(this.optionRankBar, true);
                this.startRolling()
            },

            legendSelect(params) {
                this.legendSelectBiao = params.selected['报告表']
                this.rollingFlag = false;
                this.rollingCount = 0;
                if (params.selected['报告表']) {
                    this.chartsLoadingBiao()
                } else {
                    this.chartsLoadingShu()
                }
            },

            stopRolling() {
                this.rollingFlag = false
            },

            startRolling() {
                this.rollingFlag = true;
            },

            formatDate(val) {
                let data_shu = [];
                let data_biao = [];
                if (this.selectArea === '全国') {
                    data_shu = val['报告书'].slice(0, 50);
                    data_biao = val['报告表'].slice(0, 50);
                } else {
                    data_shu = val['报告书'].slice(0, 20);
                    data_biao = val['报告表'].slice(0, 20);
                }

                let avg_shu = val['avg_baogaoshu'];
                let avg_biao = val['avg_baogaobiao'];

                let yAxis_shu = [];
                let yAxis_biao = [];

                let xAxis_shu = [];
                let xAxis_biao = [];

                for (let i in data_shu) {
                    let companyName = data_shu[i]['compile_unit__compile_unit_name']
                    if (i.length === 1) {
                        yAxis_shu.push('0' + i + companyName);
                    } else {
                        yAxis_shu.push(i + companyName);
                    }
                    xAxis_shu.push(data_shu[i]['number'])
                }

                for (let i in data_biao) {
                    let companyName = data_biao[i]['compile_unit__compile_unit_name']
                    if (i.length === 1) {
                        yAxis_biao.push('0' + i + companyName);
                    } else {
                        yAxis_biao.push(i + companyName);
                    }
                    xAxis_biao.push(data_biao[i]['number'])
                }

                return {yAxis_shu, xAxis_shu, avg_shu, yAxis_biao, xAxis_biao, avg_biao}
            }
        },
        mounted() {
            this.chartInit()
        }
    }

</script>


<style scoped>
    .content {

        height: 100vh;
        width: 1640px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }

    #unit-rank-bar {
        /*position: relative;*/
        width: 100%;
        height: 90vh;
        float: left;
        /*margin-left: 400px;*/
        /*margin-top: 30px;*/
        padding-top: 120px;
        /*background-color: #f7f7f7;*/
    }

    #time-select {
        position: relative;
        z-index: 999;
        /*left: 320px;*/
        top: 200px;
        margin-left: 180px;
        /*margin-right: auto;*/
    }

</style>